import _ from 'lodash';
import capitalize from 'capitalize';
import accounting from 'accounting';
import pluralize from 'pluralize';
import slugger from 'slugify';

const orderBy = function (items, field, dir = 'asc') {
  return _.orderBy(items, [(item) => {
    if (_.isString(item[field])) {
      return slugify(item[field]);
    } else {
      return item[field];
    }
  }], [dir]);
};

const cap = function (string) {
  if (_.isNull(string)) {
    return null;
  }
  return capitalize(string);
};

const capWords = function (string) {
  if (_.isNull(string)) {
    return null;
  }
  return capitalize.words(string);
}

const slugify = function (string) {
  if (_.isNull(string)) {
    return null;
  }
  return slugger(string);
}


export default {
  methods: {
    pluralize: pluralize,
    //accounting: accounting, // This causes vue > 2.5.13 to bomb out hard, so it needs to be removed.
    formatMoney: accounting.formatMoney,
    formatNumber: accounting.formatNumber,
    capitalize: cap,
    capitalizeWords: capWords,
    orderBy: orderBy,
    slugify: slugify,
    truncate(string, options = {}) {
      return _.truncate(string, options);
    }
  }
}
